import React from 'react';
import {Params, useLocation, useMatches} from "react-router-dom";
import { useNavigate } from "react-router-dom";

interface Match {
    id: string,
    pathname: string,
    params: Params,
    data: any,
    handle: any
}

interface BreadCrumb {
  crumb: string,
  pathname: string,
  state: {}
}

interface BreadcrumbProps {
    /** `onTeal`: white crumbs on solid teal (legacy). Prefer default on light header wash. */
    variant?: 'default' | 'onTeal';
}

function Breadcrumb({ variant = 'default' }: BreadcrumbProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const onTeal = variant === 'onTeal';

    let matches: Match[] = useMatches();

    let breadcrumbs: BreadCrumb[] = matches
      .filter((match) => Boolean(match.handle?.crumb))
      .map((match) => ({
        crumb: match.handle.crumb(location.state),
        pathname: match.pathname === '/' ? '/dashboard' : match.pathname,
        state: match.handle.state
      }));

    const breadCrumbNavigate = (isActiveCrumb: boolean, pathName: string, state: {}) => {
      if (!isActiveCrumb) {
        navigate(pathName, { state: state });
      }
    }

    const inactiveCrumb = onTeal
        ? 'text-pure-white/90 hover:text-pure-white cursor-pointer'
        : 'text-mid-grey hover:cursor-pointer';
    const activeCrumb = onTeal ? 'text-pure-white font-medium' : 'text-portal-teal font-medium';
    const separator = onTeal ? 'text-pure-white/50' : 'text-mid-grey';

    return (
      <div className={`text-p2 font-normal ${onTeal ? 'text-pure-white' : 'text-mid-grey'}`}>
        {breadcrumbs.map((breadcrumb, index) => (
          <span key={index}>
            <span className={index === breadcrumbs.length - 1 ? activeCrumb : inactiveCrumb}
                  onClick={() => breadCrumbNavigate(index === breadcrumbs.length - 1, breadcrumb.pathname, breadcrumb.state)}>
              {breadcrumb.crumb}
            </span>
            {index < breadcrumbs.length - 1 && <span className={separator}>{" / "}</span>}
          </span>
        ))}
      </div>
    );
}

export default Breadcrumb;